export enum PublicProfileTypeEnum {
  Manufacturer = 'manufacturer',
  Collector = 'collector'
}
